module.exports = __webpack_public_path__ + "img/box9-14.abfd9215.png";